import { render } from "./InfluencerListTab.vue?vue&type=template&id=b0b2b282"
import script from "./InfluencerListTab.vue?vue&type=script&lang=js"
export * from "./InfluencerListTab.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oozdemir\\Documents\\GitHub\\bootstrap-sample\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__